module.exports = __webpack_public_path__ + "img/2New.4709f4e8.jpg";